import Cookies from "universal-cookie";
import { getAlfas } from "../../../../../../../../../controllers/adicionarFichaTecnica";
import config from "../../../../../../../../../controllers/config";

export async function loadAlfas(fornecedorId) {
    const cookies = new Cookies();
    const token = cookies.get("User-Token");
    const filters = { idPessoa: fornecedorId };

    const alfas = await getAlfas(token, filters)
        .then((response) => {
            const { statusCode } = response.res;

            if (statusCode !== 200) {
                if (statusCode === false && message && message.includes("Token inválido!")) {
                    setTimeout(() => {
                        window.location.reload();
                    }, 1000);
                } else {
                    throw new Error("Campos necessários não foram retornados pelo servidor!");
                }
            }

            const body = JSON.parse(response.body);
            return body.alfas;
        })
        .catch((error) => {
            let errorString = "Erro ao carregar dados!";
            if (config.DEBUG === "TRUE") {
                errorString = error.message;
            }
        });

    return alfas;
}
